import { AxiosError } from 'axios';
import { Key, mutate } from 'swr';
import useSWRMutation from 'swr/mutation';

import {
  AccountUpdateRequestT,
  AccountUpdateResponseT,
  WithStatusT,
} from '@consumer-frontend/nc-utils';

import { apiEndpoints, applyFetchers } from '../lib';

export const useAccountUpdate = () => {
  const {
    data: accountUpdate,
    error,
    isMutating,
    trigger,
  } = useSWRMutation<
    WithStatusT<AccountUpdateResponseT>,
    AxiosError,
    Key,
    AccountUpdateRequestT
  >(
    apiEndpoints.apply.account,
    applyFetchers.put<AccountUpdateRequestT>,
    {
      onSuccess: async () => {
        mutate(apiEndpoints.apply.account);
      },
      throwOnError: false,
    },
  );

  const status = accountUpdate?.status || error?.status;

  return {
    accountUpdate,
    error,
    isMutating,
    status,
    trigger,
  };
};
